import { IQueryParams } from '../api/types'

export const apiPaths: Record<string, string> = {
  BASE_URL: '/app',
}

const DEFAULT_BACKEND_URL = 'https://progress-sn.ru/api/v1'

function normalizeApiBaseUrl(url: string): string {
  return `${url.replace(/\/+$/, '')}/`
}

export const BACKEND_URL = normalizeApiBaseUrl(
  process.env.REACT_APP_API_BASE_URL ?? DEFAULT_BACKEND_URL
)

export const BACKEND_API_URL = BACKEND_URL

export const DEFAULT_PAGE_SIZE = 50
export const MAX_PAGE_SIZE = 9999

/** Размер cursor-страницы для проверки infinite scroll; вернуть 20 перед prod. */
export const CURSOR_LIST_PAGE_SIZE = 20

/** Скользящее окно: сколько cursor-страниц держать выше/ниже якорной видимой. */
export const CURSOR_LIST_WINDOW_PAGES_BEFORE = 2
export const CURSOR_LIST_WINDOW_PAGES_AFTER = 2
export const DEFAULT_PAGE_NUMBER = 0

export const DEFAULT_QUERY_PARAMS: IQueryParams = {
  size: DEFAULT_PAGE_SIZE,
  page: DEFAULT_PAGE_NUMBER,
}

export const urlApi = {
  login: 'auth/login',
  requestEmailCode: 'auth/email/request-code',
  verifyEmailCode: 'auth/email/verify-code',
  me: 'auth/me',
  refresh: 'auth/refresh',
  logout: 'auth/logout',
  register: 'auth/register',

  competencies: 'dictionaries/competencies',
  improvements: 'dictionaries/improvements',
  resources: 'dictionaries/resources',
  participations: 'dictionaries/participations',
  focuses: 'dictionaries/focuses',

  users: 'users',

  projects: 'projects',
  comments: 'comments',
  teams: 'teams',
  growthTools: 'growth-tools',
  socialOrders: 'social-orders',
  platformReports: 'platform-reports',
  staffPlatformReports: 'staff/platform-reports',
}
